<template>
    <div class="col">
        <h3>Uppsägning</h3>
        <p>Skickas till kunder som sagt upp sitt abonnemang.</p>
        <div class="d-flex mt-2 align-items-center">
            <button class="btn btn-primary" :disabled="poster.submitted" @click="posterPost()">
                <span class="spinner-border spinner-border-sm"></span>
                Skicka
            </button>
            <div class="ps-2" v-if="company.email_contract_cancelled_sent_at">
                <i>Senast skickat: {{ company.email_contract_cancelled_sent_at }}</i>
            </div>
        </div>
    </div>
</template>

<script>
import poster from '../../../../shared/mixins/poster'

export default {

    props: {
        company: {
            required: true
        }
    },

    mixins: [
        poster
    ],

    computed: {
        posterUrl () {
            return '/companies/' + this.company.id + '/sendContractCancelledEmail'
        }
    },

    methods: {
        posterSuccess () {
            bus.$emit(
                'notify',
                'Mail om uppsägning skickat'
            )
            this.$emit('success')
        }
    }
}
</script>
